export default __webpack_public_path__ + "static/media/thesis_sample.bdcc2a8f.docx";